import data from '@/content/features'

/**
 * An Array of dashboard features, their Route slug, & product ID.
 * In order that they should appear in the Package Nav.
 */
export const features = data.features

/**
 * Dash features that should combine and override others.
 */
export const combines = [
  {
    slug: 'website',
    label: 'Website & Domain',
    combine: ['site', 'domain', 'website-files'],
  },
  {
    slug: 'stock',
    label: 'Stock Images',
    combine: ['stock-images', 'stock-icons'],
  },
]

/**
 * Map any feature product to a human readable name.
 * Useful for products we offer as upgrades that don't
 * have a dashboard feature, eg post purchase editing.
 */
export const featureMap = [
  ...features,
  { label: 'Logo Editing', product: 'edits' },
]

/**
 * Build the correct Package Dash link based on the current route.
 *
 * @param {object} $route The Nuxt Route instance
 */
export const packageDash = ({ params }) => {
  // const dash = name.startsWith('p-pkg') ? 'p' : 'dashboard'
  const dash = 'dashboard'

  return `/${dash}/${params.pkg}`
}

/**
 * Check if file is using the black-foreground white-background logo
 * @param {*} file RTF file object
 * @returns true if file uses black palette
 */
export const fileUsesBlackPalette = file => {
  return (
    file.accent === '#000000' &&
    file.primary === '#000000' &&
    file.secondary === '#000000' &&
    file.quaternary === '#ffffff' &&
    file.tertiary === '#000000'
  )
}

/**
 * Check if file is using the white-foreground black-background logo
 * @param {*} file RTF file object
 * @returns true if file uses white palette
 */
export const fileUsesWhitePalette = file => {
  return (
    file.accent === '#ffffff' &&
    file.primary === '#ffffff' &&
    file.secondary === '#ffffff' &&
    file.quaternary === '#000000' &&
    file.tertiary === '#ffffff'
  )
}
